import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import uuid from "react-uuid";
import useStyles from "../../../../styles";
import ReactQuill from "react-quill";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import InputForm from "../../Form/CreateForm/InputForm";

function AddGenerateRegistrationLinkForm() {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [formType, setFormType] = useState("text");

  const initialQuillData = {
    id: uuid(),
    value: null,
    type: formType,
    required: false,
  };

  const [quillData, setQuillData] = useState([initialQuillData]);

  const [exams, setExams] = useState();
  const [selectedExamId, setSelectedExamId] = useState();
  console.log("quillData", quillData);
  const [document, setDocument] = useState({
    uploadidproof: false,
    uploaddobproof: false,
    uploadphoto: false,
    livephoto: false,
    upload1012certificate: false,
    uploadsignature: false,
    uploadrightthumb: false,
    uploadleftthumb: false,
    liverightthumb: false,
    liveleftthumb: false,
  });

  const [instructionData, setinstructionData] = useState();
  const [formFeesContent, setFormFeesContent] = useState();

  const [formModules, setFormModules] = useState({
    instruction: true,
    personaldetails: true,
    qualificationdetails: true,
    communicationdetails: true,
    additionaldetails: false,
    centreselection: false,
    uploaddocuments: true,
    applicationpreview: true,
    payexamfee: false,
    applicationstatus: true,
    postselection: false,
    employmentdetails: false,
    name: "",
    exam_id: "",
    form_fees: null,
    your_payment_gateway: "no",
    razorpay_api_key: "",
    razorpay_api_secret: "",
  });

  const quillModules = {
    toolbar: [
      [
        "bold",
        "italic",
        "underline",
        "strike",
        { script: "sub" },
        { script: "super" },
        { color: [] },
        { background: [] },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["code-block"],
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "list",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "link",
    "blockquote",
    "code-block",
    "align",
    "image",
  ];

  const classes = useStyles();

  const handleClose = () => {
    navigate("/admin/registrationlink");
  };

  const handleExamChange = (event, value) => {
    setSelectedExamId(value.id);
  };

  const handleFormSubmit = () => {
    if (!selectedExamId) {
      toast.warn("Please select an exam.");
      return;
    }

    const registration = {
      registration: {
        name: formModules.name,
        centreselection: formModules.centreselection,
        uploaddocuments: formModules.uploaddocuments,
        applicationpreview: formModules.applicationpreview,
        payexamfee: formModules.payexamfee,
        applicationstatus: formModules.applicationstatus,
        instruction: formModules.instruction,
        personaldetails: formModules.personaldetails,
        qualificationdetails: formModules.qualificationdetails,
        postselection: formModules.postselection,
        communicationdetails: formModules.communicationdetails,
        employmentdetails: formModules.employmentdetails,
        additionaldetails: formModules.additionaldetails,
        exam_id: selectedExamId, // Use the selected exam ID here
        fields: quillData,
        document: document,
        instruction_content: instructionData,
        form_fees_content: formFeesContent,
        form_fees: formModules.form_fees,
        your_payment_gateway: formModules.your_payment_gateway,
        razorpay_api_key: formModules.razorpay_api_key,
        razorpay_api_secret: formModules.razorpay_api_secret,
      },
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link/add`,
        registration,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        const uniqueId = response.data?.registration?.registration_code;
        const link = `https://registration.eduprohub.in/${uniqueId}`;
        toast.success(`Link generated: ${link}`);
        setTimeout(() => {
          navigate("/admin/registrationlink");
        }, 2000);
      })
      .catch((error) => {
        toast.error("Failed to generate link");
        console.error(error);
      });
  };

  const fetchExams = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setExams(data.exams);
      } else {
        console.error("Failed to fetch exam data");
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    fetchExams();
  }, []);

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Form Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  checked={formModules.name}
                  onChange={(e) =>
                    setFormModules({
                      ...formModules,
                      [e.target.name]: e.target.value,
                    })
                  }
                  type="text"
                  name="name"
                  variant="outlined"
                  required
                  placeholder="Enter Form Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  id="state-autocomplete"
                  options={exams || []}
                  value={selectedExamId}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleExamChange}
                  disableClearable
                  getOptionLabel={(option) => option?.exam_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Form Modules
              </Typography>
              <div
                className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="instruction"
                      color="primary"
                      checked={formModules.instruction}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Instruction"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="personaldetails"
                      color="primary"
                      checked={formModules.personaldetails}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Personal Details"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="qualificationdetails"
                      color="primary"
                      checked={formModules.qualificationdetails}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Qualification Details"
                />

                {/* <FormControlLabel
                  control={
                    <Checkbox
                      name="postselection"
                      color="primary"
                      checked={formModules.postselection}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Post Selection"
                /> */}

                <FormControlLabel
                  control={
                    <Checkbox
                      name="communicationdetails"
                      color="primary"
                      checked={formModules.communicationdetails}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Communication Details"
                />

                {/* <FormControlLabel
                  control={
                    <Checkbox
                      name="employmentdetails"
                      color="primary"
                      checked={formModules.employmentdetails}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Employment Details"
                /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      name="additionaldetails"
                      color="primary"
                      checked={formModules.additionaldetails}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Additional Details"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="centreselection"
                      color="primary"
                      checked={formModules.centreselection}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="City Selection"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="uploaddocuments"
                      color="primary"
                      checked={formModules.uploaddocuments}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Upload Documents"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="applicationpreview"
                      color="primary"
                      checked={formModules.applicationpreview}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Application Preview"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="payexamfee"
                      color="primary"
                      checked={formModules.payexamfee}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Pay Exam Fee"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="applicationstatus"
                      color="primary"
                      checked={formModules.applicationstatus}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Application Status"
                />
              </div>
            </div>
          </div>
          {formModules.instruction && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Instruction
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
                >
                  <ReactQuill
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.quilladdsinglequestion}`}
                    // value={
                    //   link === "Hindi"
                    //     ? quillContentHindiSolution[optionIndex] || ""
                    //     : quillContentEnglishSolution[optionIndex] || ""
                    // }
                    // onChange={(e) => {
                    //   // Update the respective solution for the selected option
                    //   if (link === "Hindi") {
                    //     const newHindiSolutions = [...quillContentHindiSolution];
                    //     newHindiSolutions[optionIndex] = e;
                    //     setQuillContentHindiSolution(newHindiSolutions);
                    //   } else {
                    //     const newEnglishSolutions = [
                    //       ...quillContentEnglishSolution,
                    //     ];
                    //     newEnglishSolutions[optionIndex] = e;
                    //     setQuillContentEnglishSolution(newEnglishSolutions);
                    //   }
                    // }}
                    name="instructioncontent"
                    onChange={(e) => {
                      setinstructionData(e);
                    }}
                    instruction_content
                    modules={quillModules}
                    formats={quillFormats}
                  />
                </div>
              </div>
            </div>
          )}

          {formModules.additionaldetails && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Additional Details
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
                >
                  <InputForm
                    quillData={quillData}
                    setQuillData={setQuillData}
                    formType={formType}
                    setFormType={setFormType}
                  />
                </div>
              </div>
            </div>
          )}
          {formModules.uploaddocuments && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Upload Documents
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadidproof"
                        color="primary"
                        checked={document.uploadidproof}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload ID Proof"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadphoto"
                        color="primary"
                        checked={document.uploadphoto}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Photo"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="upload1012certificate"
                        color="primary"
                        checked={document.upload1012certificate}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload 10th/10+2 Certificate"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadrightthumb"
                        color="primary"
                        checked={document.uploadrightthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Right Thumb"
                  />
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        name="liverightthumb"
                        color="primary"
                        checked={document.liverightthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Live Right Thumb"
                  /> */}
                </div>
                <div
                  className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploaddobproof"
                        color="primary"
                        checked={document.uploaddobproof}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload DOB Proof"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="livephoto"
                        color="primary"
                        checked={document.livephoto}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Live Photo"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadsignature"
                        color="primary"
                        checked={document.uploadsignature}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Signature"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadleftthumb"
                        color="primary"
                        checked={document.uploadleftthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Left Thumb"
                  />
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        name="liveleftthumb"
                        color="primary"
                        checked={document.liveleftthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Live Left Thumb"
                  /> */}
                </div>
              </div>
            </div>
          )}
          {formModules.payexamfee && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Form Fees Content
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
                >
                  <ReactQuill
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.quilladdsinglequestion}`}
                    // value={
                    //   link === "Hindi"
                    //     ? quillContentHindiSolution[optionIndex] || ""
                    //     : quillContentEnglishSolution[optionIndex] || ""
                    // }
                    // onChange={(e) => {
                    //   // Update the respective solution for the selected option
                    //   if (link === "Hindi") {
                    //     const newHindiSolutions = [...quillContentHindiSolution];
                    //     newHindiSolutions[optionIndex] = e;
                    //     setQuillContentHindiSolution(newHindiSolutions);
                    //   } else {
                    //     const newEnglishSolutions = [
                    //       ...quillContentEnglishSolution,
                    //     ];
                    //     newEnglishSolutions[optionIndex] = e;
                    //     setQuillContentEnglishSolution(newEnglishSolutions);
                    //   }
                    // }}
                    name="form_fees_content"
                    onChange={(e) => {
                      setFormFeesContent(e);
                    }}
                    instruction_content
                    modules={quillModules}
                    formats={quillFormats}
                  />
                </div>
              </div>
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Payment
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Form Fees <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    value={formModules.form_fees}
                    onChange={(e) =>
                      setFormModules({
                        ...formModules,
                        [e.target.name]: e.target.value,
                      })
                    }
                    type="number"
                    name="form_fees"
                    variant="outlined"
                    required
                    placeholder="Enter Form Fees"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Your Payment Gateway{" "}
                    <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <RadioGroup
                    className={`${classes.radiocolor}`}
                    row
                    aria-label="Question Mark System"
                    name="your_payment_gateway"
                    onChange={(e) =>
                      setFormModules({
                        ...formModules,
                        [e.target.name]: e.target.value,
                      })
                    }
                    value={formModules.your_payment_gateway}
                    // value={questionMarkSystem}
                    // onChange={(e) =>
                    //   handleFormChange("question_mark_system", e.target.value)
                    // }
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                        // onClick={() => setQuestionMarkSystem("same")}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                        // onClick={() => setQuestionMarkSystem("different")}
                        />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                ></div>
              </div>
              {formModules.your_payment_gateway === "yes" && (
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  >
                    Payment Gateway Config
                  </Typography>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Key Id <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      value={formModules.razorpay_api_key}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.value,
                        })
                      }
                      type="text"
                      name="razorpay_api_key"
                      variant="outlined"
                      required
                      placeholder="Enter Here"
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Key Secret <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      checked={formModules.razorpay_api_secret}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.value,
                        })
                      }
                      type="text"
                      name="razorpay_api_secret"
                      variant="outlined"
                      required
                      placeholder="Enter Here"
                    />
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                </div>
              )}
            </div>
          )}

          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleClose}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddGenerateRegistrationLinkForm;
